<div class="update-dialog">
  <h3>{{ 'orders.positions.bm.updateMeasures.title' | translate }}</h3>

  <form [formGroup]="form" class="update-form" #updateForm>
    <mat-form-field>
      <mat-label>{{ 'orders.positions.bm.updateMeasures.length' | translate }}</mat-label>
      <input formControlName="length" matInput/>
      <span matTextSuffix>mm</span>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'orders.positions.bm.updateMeasures.width' | translate }}</mat-label>
      <input formControlName="width" matInput/>
      <span matTextSuffix>mm</span>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'orders.positions.bm.updateMeasures.quantity' | translate }}</mat-label>
      <input formControlName="quantity" matInput/>
    </mat-form-field>
  </form>

  <div class="dialog-buttons">
    <button mat-button (click)="cancel()">{{ 'orders.positions.bm.updateMeasures.cancel' | translate }}</button>
    <button [disabled]="!form.valid" mat-raised-button color="primary"
            (click)="submit()">{{ 'orders.positions.bm.updateMeasures.submit' | translate }}
    </button>
  </div>
</div>
